
import AnimatedSprite from "slotworks/graphics/animation/animated-sprite";
import { Flexi } from "slotworks/graphics/elements/abstract-flexi";

export default class FlexiSprite extends Flexi<AnimatedSprite | PIXI.Sprite | HTMLElement> {

    public setVisible(visible: boolean) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.classList.toggle(visible ? "hidden" : "visible", false);
                target.classList.toggle(visible ? "visible" : "hidden", true);
            } else {
                target.visible = visible;
            }
        }
    }

    public setAlpha(alpha: number) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.style.opacity = `${alpha}`;
            } else {
                target.alpha = alpha;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/elements/flexi-sprite.ts